import { Component, OnDestroy, OnInit, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";
import { DetalleOOTTComponent } from "../../oott/detalle-oott/detalle-oott.component";
import { ClienteDTO } from "../../shared/interfaces/cliente.interface";
import { FiltroOrdenesCompra } from "../../shared/interfaces/filtro-ordenescompra.interface";
import { Filtro } from "../../shared/interfaces/filtro.interface";

import { NuevaFacturaDTO } from "../../shared/models/factura.model";
import { OrdenCompraDTO } from "../../shared/models/orden-compra.model";
import { ClienteService } from "../../shared/services/rest/cliente.service";
import { CodigosService } from "../../shared/services/rest/codigos.service";
import { DialogService } from "../../shared/services/rest/dialog.service";
import { FacturaService } from "../../shared/services/rest/factura.service";
import { NotificacionesService } from "../../shared/services/rest/notificaciones.service";
import { OrdenesCompraService } from "../../shared/services/rest/orden-compra.service";
import { FiltrosService } from "../../shared/services/util/filtros.service";
import { MenuUsuarioService } from "../../shared/services/util/menu-usuario.service";

import { DialogAsociarFacturaOoccComponent } from "./components/dialog-asociar-factura-oocc/dialog-asociar-factura-oocc.component";
import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";
@Component({
    selector: "app-oocc",
    templateUrl: "./oocc.component.html",
    styleUrls: ["./oocc.component.scss"],
})
export class OoccComponent implements OnInit, OnDestroy {
    total: number;
    oocc: OrdenCompraDTO[];
    //configuracionOOCC: any = {};
    subscripciones: Subscription;
    estados: Filtro[];
    mostrarFiltros: boolean;
    clientes: ClienteDTO[];
    setearFiltros: boolean;
    recepciones: Filtro[];

    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _ordenesCompraSrvc: OrdenesCompraService,
        private _facturasSrvc: FacturaService,
        private _dialogSrvc: DialogService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _filtroSrvc: FiltrosService,
        private _notificacionSrvc: NotificacionesService,
        private _clienteSrvc: ClienteService,
        private _menuUsuarioSrvc: MenuUsuarioService,
        private _codigosSrvc: CodigosService,
        private activatedRoute: ActivatedRoute
    ) {
        this._filtroSrvc.getFiltro("filtrosOOCC");
        this.activatedRoute.queryParams.subscribe((queryParams) => {
            if (Object.entries(queryParams).length > 0) {
                this.setearFiltros = true;
                this.mostrarFiltros = true;
                //setear los filtros
                if (queryParams.idEstado) {
                    this._filtroSrvc.setFiltro(
                        "filtrosOOCC",
                        "estado",
                        queryParams.idEstado,
                        queryParams.nombre
                    );
                }
                if (queryParams.idRecepcion) {
                    this._filtroSrvc.setFiltro(
                        "filtrosOOCC",
                        "recepcion",
                        queryParams.idRecepcion,
                        queryParams.nombreRecepcion
                    );
                }
            } else {
                this.mostrarFiltros = false;
                this.setearFiltros = false;
            }
        });

        this.subscripciones = new Subscription();
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
        //this._filtroSrvc.initFiltrosOOCC();
    }

    ngOnInit(): void {
        this.buscarOrdenesCompra();

        this.estados = [
            {
                valor: 1,
                descripcion: "No facturados",
                tipo: null,
            },
            {
                valor: 2,
                descripcion: "Facturados",
                tipo: null,
            },
        ];

        this.recepciones = [
            {
                valor: 1,
                descripcion: "No recibidas",
                tipo: null,
            },
            {
                valor: 2,
                descripcion: "Recibidas",
                tipo: null,
            },
        ];

        if (this._menuUsuarioSrvc.esSupervisor()) {
            this._clienteSrvc
                .fetchClientes(0, "desc")
                .subscribe((resp) => (this.clientes = resp.content));
        } else {
            this.clientes = [];
        }
    }

    verOOTT(idOOTT: number) {
        this._dialogSrvc.abrirDialog(
            DetalleOOTTComponent,
            "clase-dialog",
            "800px",
            idOOTT
        );
    }

    asociarFactura(oocc: OrdenCompraDTO[]) {
        this._codigosSrvc.fetchUF().subscribe(
            (uf) => {
                const data = {
                    oocc,
                    uf,
                };
                this.cargaModal(data, oocc);
            },
            (err) => {
                const data = {
                    oocc,
                    uf: 0,
                };
                this.cargaModal(data, oocc);
            }
        );
    }

    cargaModal(data: any, oocc: OrdenCompraDTO[]) {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogAsociarFacturaOoccComponent,
            "clase-dialog",
            "700px",
            data
        );

        const ordenes = oocc.map((oc) => oc.id);

        dialogRef.afterClosed().subscribe((factura) => {
            if (factura) {
                let nuevo = new NuevaFacturaDTO(
                    oocc[0].cliente.id,
                    factura.nroFactura,
                    factura.fecha.toISOString(),
                    factura.montoBruto,
                    factura.iva,
                    oocc[0].rutFacturar,
                    ordenes
                );
                let c = this._facturasSrvc.save(nuevo).subscribe((resp) => {
                    this._ordenesCompraSrvc.ooccRefresh$.next(true);
                    this._notificacionSrvc.mostrarNotificacion(
                        "Factura asociada correctamente",
                        "success"
                    );
                });
            }
        });
    }

    filtrar(event: FiltroOrdenesCompra) {
        this._ordenesCompraSrvc.resetPaginador();
        this._ordenesCompraSrvc.ooccRefresh$.next(true);
    }

    buscarOrdenesCompra() {
        this._fuseProgressBarService.show();
        this.subscripciones.add(
            this._ordenesCompraSrvc
                .fetchOrdenesCompra()
                .pipe(finalize(() => this._fuseProgressBarService.hide()))
                .subscribe((resp) => {
                    this.total = resp.totalElements;
                    this.oocc = resp.content;
                    this._ordenesCompraSrvc.ordenesChanged$.next(resp);
                    this._ordenesCompraSrvc.setCantidadPaginas(resp.totalPages);
                    //this._ordenesCompraSrvc.setTotalDeResultados(
                    //    resp.totalElements
                    //);
                    this._ordenesCompraSrvc.setPaginaActual(
                        resp.pageable.pageNumber
                    );
                    this._ordenesCompraSrvc.setCantidaResultadosPorPagina(
                        resp.size
                    );
                })
        );
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
